import React from 'react';
import './HeroHeading.css';

export function HeroHeading() {
  return (
    <div className="hero-heading">
      <h1 className="hero-heading__top-title">
        당신의 필요에 딱 맞는
      </h1>
      <span className="hero-heading__accent-title">
        스마트 양궁 기록 분석
      </span>
    </div>
  );
}
